import React, {useEffect, useState, useRef} from 'react';
import { useDispatch } from 'react-redux';
import {alertService} from '@app/services/alertService';
import {myService} from '@app/services/thongbaoService';
import * as mainService from '@app/services/mainService';
import {useLocation} from 'react-router-dom';
import {getControllerName} from '@app/utils/helpers';
import HeaderClick from '@app/utils/HeaderClick';
import {checkRole} from '@app/services/mainService';
import {Button, Modal} from "react-bootstrap";
import {Tabs, HRTag} from "@components";
import {
    INIT_ROLE_MENU
} from "@app/const/AppSetting";
import {useTranslation} from "react-i18next";
import LoaithongbaoListComponent from '@app/pages/FUtil/LoaithongbaoListComponent';
import Editor from '@app/pages/FUtil/Editor';
import TailieuEdit from '@app/pages/FMasterData/FThongbao/TailieuEdit';
import './buttonmoveto.css';

import { ChromePicker } from "react-color";
import TrangthaiListComponent from "@pages/FUtil/TrangthaiListComponent";
import {ClipLoader} from "react-spinners";
import CoquanListComponent from "@pages/FUtil/CoquanListComponent";

function ThongbaoEdit({history, match}) {
    const [t] = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();

    const currController = getControllerName(location.pathname);
    const [loading, setLoading] = useState(false);

    let {id} = match.params;
    let isAddMode = !id;
    const isDisplay = id && location.pathname.indexOf(`view`) > 0;
    const [handleToogle, setHandleToogle] = useState(false);
    const [loadPageToogle, setLoadPageToogle] = useState(false);
    const [hasRole, setHasRole] = useState(false);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);

    // Refs for scrollTo functionality
    const taiLieuRef = useRef(null);
    const thongTinRef = useRef(null);
    const phanQuyenRef = useRef(null);
    const mauSacRef = useRef(null);

    // ScrollTo functions
    const scrollToThongtin = () => {
        thongTinRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToMauSac = () => {
        mauSacRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToPhanQuyen = () => {
        phanQuyenRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToTaiLieu = () => {
        taiLieuRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const initial = {
        id: id || 0,
        tieu_de : '',
        noi_dung_rut_gon: '',
        noi_dung: '',
        isghimlendau:false,
        loaithongbao_fk : null,
        color1: '',
        color2:'',
        color3:'',
        coquan_fk: null,
        trangthai_fk: null,
        apdung: 0,
        nhadan_fks: [],
        capcoquan_fks: [],
        all: false
    };

    const chonNhadan = (position,e) => {
        const {name, value, checked} = e.target;
        let q;
        let mAll;
        if(position === -1)
        {
            q = obj.nhadan_fks.map(obj=> ({ ...obj, checked: checked })) ;
            mAll = checked;
        }
        else
        {
            q = obj.nhadan_fks;
            q[position]['checked']= checked;
            mAll = obj.all;
        }
        setObj((prevState) => ({
            ...prevState,
            nhadan_fks: q,
            all:mAll
        }));
        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
    };

    const chonCapcoqquan = (position,e) => {
        const {name, value, checked} = e.target;
        let q;
        let mAll;
        if(position === -1)
        {
            q = obj.capcoquan_fks.map(obj=> ({ ...obj, checked: checked })) ;
            mAll = checked;
        }
        else
        {
            q = obj.capcoquan_fks;
            q[position]['checked']= checked;
            mAll = obj.all;
        }
        setObj((prevState) => ({
            ...prevState,
            capcoquan_fks: q,
            all:mAll
        }));
        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
    };

    const [obj, setObj] = useState({...initial});

    const onChangeInput =  (e) => {
        console.log(e.target);
        const {name, value, checked, type} = e.target;

        if(type ==='checkbox') {
            setObj((prevState) => ({
                ...prevState,
                [name]: checked
            }));
        }
        else
        {
            setObj((prevState) => ({
                ...prevState,
                [name]: value
            }));
        }

        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
    };

    const createRs = async () => {
        setLoading(true);
        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);
            setRoleMenu(role);
            setHasRole(true);
        }

        if (!isAddMode) {
            myService.getById(id).then((response) => {
                console.log('getById', JSON.stringify(response, null, 2));

                if(!response || !response.data || !response.data.data)
                {
                    history.push('/'+currController);
                    alertService.error('Thông tin theo Id không tồn tại hoặc không thuộc quyền của bạn');
                }

                let userX = response.data.data;
                console.log(userX);
                setObj(userX);
            });
        }
        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
        setLoading(false);
    };

    useEffect(async () => {
        await checkRole({
            pathname: location.pathname,
            isAddMode,
            currController,
            history
        });

        await createRs();
    }, []);

    useEffect(async () => {
        if(loadPageToogle && !loading) {
            setLoadPageToogle(false);
            await checkRole({
                pathname: location.pathname,
                isAddMode,
                currController,
                history
            });

            await createRs();
        }
    }, [loading]);

    const saveClick = async () => {
        let data = obj;
        if(!data)
        {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }

        if(!data.tieu_de || data.tieu_de.length === 0)
        {
            alert('Vui lòng nhập tiêu đề');
            return;
        }
        if(!data.loaithongbao_fk || data.loaithongbao_fk.length === 0)
        {
            alert('Vui lòng chọn loại thông báo');
            return;
        }
        if(!data.noi_dung_rut_gon || data.noi_dung_rut_gon.length === 0)
        {
            alert('Vui lòng nhập nội dung rút gọn');
            return;
        }
        if(!data.noi_dung || data.noi_dung.length === 0)
        {
            alert('Vui lòng nhập nội dung');
            return;
        }

        isAddMode ? createThongbao(data) : update(data);
    };

    const backBrowse = () => {
        history.push('/'+currController);
    };

    async function createThongbao(data) {
        setLoading(true);
        const result = await myService.Create(data);
        if (result.status ==="1") {
            alertService.success(result.msg);
            history.push('/'+currController+'/edit/'+ result.data );
        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }

    async function update(data) {
        setLoading(true);
        const result = await myService.Update(id,data);

        if (result.status ==="1") {
            alertService.success(result.msg);
        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }

    let htmlButtonSave = '';

    if(isDisplay <= 0 || isAddMode > 0){
        htmlButtonSave = (
            <Button
                className="btn btn-success mr-1"
                icon="right fas fa-angle-left"
                onClick={saveClick}
            >
                <i className="fa fa-save"> {isAddMode>0 ? "Tạo mới" :"Cập nhật"} </i>
            </Button>
        );
    }

    // CSS Styles
    const formLabelStyle = {
        fontWeight: '500',
        color: '#495057',
        marginBottom: '5px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    };

    const formControlStyle = {
        border: '1px solid #ced4da',
        borderRadius: '6px',
        padding: '8px 12px',
        fontSize: '14px',
        transition: 'all 0.3s ease',
        backgroundColor: '#fff'
    };

    const iconStyle = {
        fontSize: '14px',
        marginRight: '8px'
    };

    const colorPickerContainerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    };

    return (
        <div className="card card-primary" disabled={loading}>
            <HeaderClick
                headerName={roleMenu.tenmenu}
                isAddMode={isAddMode}
                isDisplay={isDisplay}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                {/* Navigation buttons - Fixed on right side */}
                { !isAddMode && (
                    <div style={{
                        position: 'fixed',
                        right: '0',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: '1000',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px'
                    }}>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToThongtin}
                        >
                            Thông tin chung
                        </button>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #ffc107 0%, #e0a800 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToMauSac}
                        >
                            Màu sắc
                        </button>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToPhanQuyen}
                        >
                            Phân quyền
                        </button>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToTaiLieu}
                        >
                            Tài liệu
                        </button>
                    </div>
                )}

                {loading ? (
                    <div className="flex justify-center items-center h-40">
                        <ClipLoader color="#3498db" size={50} />
                    </div>
                ) : (
                    <div className="form-row p-2">
                        <Button className="btn btn-secondary  mr-1"  onClick={() => backBrowse()}>
                            <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                        </Button>
                        {htmlButtonSave}
                    </div>
                )}

                <div className="tab-pane fade show active" id="thongtinnhanvien">
                    <div className="card-body" ref={thongTinRef}>
                        <HRTag title="Thông tin cập nhật"/>

                        {/* Row 1: Cơ quan */}
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <CoquanListComponent
                                    required="required"
                                    coquan_fk={obj.coquan_fk}
                                    onChange={(opt, e) => {
                                        const target = {name: "coquan_fk", value: opt?.value};
                                        onChangeInput({target});
                                    }}
                                />
                            </div>
                        </div>

                        {/* Row 2: Loại thông báo và Trạng thái */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <LoaithongbaoListComponent
                                    required="required"
                                    loaithongbao_fk={obj.loaithongbao_fk}
                                    onChange={(opt, e) => {
                                        const target = {name: "loaithongbao_fk", value: opt?.value};
                                        onChangeInput({target});
                                    }}
                                />
                            </div>
                            {!isAddMode && (
                                <div className="col-md-6">
                                    <TrangthaiListComponent
                                        trangthai_fk={obj.trangthai_fk}
                                        onChange={(opt, e) => {
                                            const target = {name: "trangthai_fk", value: opt?.value};
                                            onChangeInput({target});
                                        }}
                                        filterIds={[0,1]}
                                        trangthaiName="name"
                                    />
                                </div>
                            )}
                        </div>

                        {/* Row 3: Tiêu đề và Ghim lên đầu */}
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <label style={{...formLabelStyle, fontWeight: '600'}}>
                                    <i className="fas fa-heading text-primary" style={iconStyle}></i>
                                    Tiêu đề <span style={{color: '#dc3545', marginLeft: '3px'}}>*</span>
                                </label>
                                <input
                                    type='text'
                                    className="form-control"
                                    style={formControlStyle}
                                    name="tieu_de"
                                    id="tieu_de"
                                    value={obj.tieu_de}
                                    onChange={(e) => onChangeInput(e)}
                                    placeholder="Nhập tiêu đề thông báo"
                                />
                                <div style={{marginTop: '10px'}}>
                                    <label style={{fontWeight: 'normal', cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                                        <input
                                            type="checkbox"
                                            name='isghimlendau'
                                            value={obj.isghimlendau}
                                            checked={obj.isghimlendau}
                                            onChange={(e) => onChangeInput(e)}
                                            style={{marginRight: '8px'}}
                                        />
                                        <i className="fas fa-thumbtack text-warning" style={{marginRight: '5px'}}></i>
                                        Ghim lên đầu trang
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Row 4: Nội dung rút gọn */}
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <label style={formLabelStyle}>
                                    <i className="fas fa-align-left text-info" style={iconStyle}></i>
                                    Nội dung rút gọn <span style={{color: '#dc3545', marginLeft: '3px'}}>*</span>
                                </label>
                                <Editor
                                    name="noi_dung_rut_gon"
                                    value={obj.noi_dung_rut_gon}
                                    onChange={onChangeInput}
                                    readonly={isDisplay ? "readonly" : ""}
                                />
                            </div>
                        </div>

                        {/* Row 5: Nội dung */}
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <label style={formLabelStyle}>
                                    <i className="fas fa-file-alt text-success" style={iconStyle}></i>
                                    Nội dung <span style={{color: '#dc3545', marginLeft: '3px'}}>*</span>
                                </label>
                                <Editor
                                    name="noi_dung"
                                    value={obj.noi_dung}
                                    onChange={onChangeInput}
                                    readonly={isDisplay ? "readonly" : ""}
                                />
                            </div>
                        </div>

                        {/* Màu sắc Section */}
                        <div ref={mauSacRef}>
                            <HRTag title="Cài đặt màu sắc" />
                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <label style={formLabelStyle}>
                                        <i className="fas fa-palette text-danger" style={iconStyle}></i>
                                        Mã màu 1
                                    </label>
                                    <div style={colorPickerContainerStyle}>
                                        <ChromePicker
                                            name="color1"
                                            id="color1"
                                            color={obj.color1}
                                            onChangeComplete={color => {
                                                const target = {name: "color1", value: color?.hex};
                                                onChangeInput({target});
                                            }}
                                            disableAlpha={true}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <label style={formLabelStyle}>
                                        <i className="fas fa-palette text-warning" style={iconStyle}></i>
                                        Mã màu 2
                                    </label>
                                    <div style={colorPickerContainerStyle}>
                                        <ChromePicker
                                            name="color2"
                                            id="color2"
                                            color={obj.color2}
                                            onChangeComplete={color => {
                                                const target = {name: "color2", value: color?.hex};
                                                onChangeInput({target});
                                            }}
                                            disableAlpha={true}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <label style={formLabelStyle}>
                                        <i className="fas fa-palette text-info" style={iconStyle}></i>
                                        Mã màu 3
                                    </label>
                                    <div style={colorPickerContainerStyle}>
                                        <ChromePicker
                                            name="color3"
                                            id="color3"
                                            color={obj.color3}
                                            onChangeComplete={color => {
                                                const target = {name: "color3", value: color?.hex};
                                                onChangeInput({target});
                                            }}
                                            disableAlpha={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Phân quyền Section */}
                        <div ref={phanQuyenRef}>
                            {!isAddMode && (
                                <>
                                    <HRTag title="Phân quyền áp dụng" />
                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <label style={formLabelStyle}>
                                                <i className="fas fa-users-cog text-primary" style={iconStyle}></i>
                                                Áp dụng cho:
                                            </label>
                                            <select
                                                className="form-control"
                                                style={formControlStyle}
                                                value={obj.apdung}
                                                name="apdung"
                                                onChange={(e) => onChangeInput({ target: { name: e.target.name, value: parseInt(e.target.value, 10) } })}
                                            >
                                                <option value="0">Tất cả</option>
                                                <option value="1">Các đạo hữu tại nhà đàn chỉ định</option>
                                                <option value="2">Chọn Cấp Cơ Quan (multi)</option>
                                            </select>
                                        </div>
                                    </div>

                                    {obj.apdung === 1 && (
                                        <div className="row">
                                            <div className="col-md-12">
                                                <HRTag title="Thông báo tới các nhà đàn chỉ định" />
                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-hover text-nowrap">
                                                        <thead>
                                                        <tr>
                                                            <th className="col-md-1 text-center">ID</th>
                                                            <th className="col-md-1 text-center">Tên</th>
                                                            <th className="col-md-1 text-center">
                                                                Chọn
                                                                <input
                                                                    type="checkbox"
                                                                    id="custom-checkbox-all"
                                                                    value={obj.all}
                                                                    checked={obj.all}
                                                                    onChange={(e) => chonNhadan(-1,e)}
                                                                    style={{marginLeft: '5px'}}
                                                                />
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {obj.nhadan_fks && obj.nhadan_fks.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.value}</td>
                                                                <td>{item.label}</td>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`custom-checkbox-${index}`}
                                                                        value={item.checked}
                                                                        checked={obj.nhadan_fks[index]?.checked}
                                                                        onChange={(e) => chonNhadan(index,e)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {obj.apdung === 2 && (
                                        <div className="row">
                                            <div className="col-md-12">
                                                <HRTag title="Phân quyền cấp cơ quan được thấy thông báo" />
                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-hover text-nowrap">
                                                        <thead>
                                                        <tr>
                                                            <th className="col-md-1 text-center">ID</th>
                                                            <th className="col-md-1 text-center">Tên</th>
                                                            <th className="col-md-1 text-center">
                                                                Chọn
                                                                <input
                                                                    type="checkbox"
                                                                    id="custom-checkbox-all-cq"
                                                                    value={obj.all}
                                                                    checked={obj.all}
                                                                    onChange={(e) => chonCapcoqquan(-1,e)}
                                                                    style={{marginLeft: '5px'}}
                                                                />
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {obj.capcoquan_fks && obj.capcoquan_fks.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.value}</td>
                                                                <td>{item.label}</td>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`custom-checkbox-cq-${index}`}
                                                                        value={item.checked}
                                                                        checked={obj.capcoquan_fks[index]?.checked}
                                                                        onChange={(e) => chonCapcoqquan(index,e)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                        {/* Tài liệu Section */}
                        {!isAddMode && (
                            <div ref={taiLieuRef}>
                                <HRTag title="Tài liệu" />
                                <TailieuEdit id={id} />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="card-footer">
                <div className="form-row p-2">
                    <Button className="btn btn-secondary mr-1" onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                    </Button>
                    {htmlButtonSave}
                </div>
            </div>
        </div>
    );
}

export {ThongbaoEdit};